import React, { useMemo } from 'react';

import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { MerchantAccess } from 'types/embedded/merchantAccess';

type Props = {
  setOpenDisableDialog: (v: boolean) => void;
  setSelectedAccesses: (v: MerchantAccess[]) => void;
};

export const MerchantShowAccessBulkDisableButton: React.FC<Props> = ({
  setOpenDisableDialog,
  setSelectedAccesses,
}) => {
  const translate = useTypedTranslate();
  const { data: allMerchantAccesses, selectedIds } = useListContext<MerchantAccess>();

  const selectedMerchantAccesses = useMemo(
    () => allMerchantAccesses?.filter((merchantAccess) => selectedIds?.includes(merchantAccess.id)),
    [allMerchantAccesses, selectedIds],
  );

  const onBulkActionClick = () => {
    setSelectedAccesses(selectedMerchantAccesses || []);
    setOpenDisableDialog(true);
  };

  return (
    <Button
      color="error"
      label={translate('app.merchantAccess.reset')}
      onClick={onBulkActionClick}
      startIcon={<RemoveCircleOutlineIcon />}
    />
  );
};
